var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 38,
    fill: "#73151F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.8081 67.4791H40.1921C33.2614 67.4791 27.6223 61.8399 27.6223 54.9084V41.1475C27.6223 34.2168 33.2614 28.5786 40.1921 28.5786H55.8081C62.7379 28.5786 68.377 34.2168 68.377 41.1475V54.9084C68.377 61.8391 62.7379 67.4791 55.8081 67.4791ZM40.1921 31.3715C34.801 31.3715 30.4161 35.7573 30.4161 41.1475V54.9084C30.4161 60.2995 34.801 64.6844 40.1921 64.6844H55.8081C61.1983 64.6844 65.5841 60.2986 65.5841 54.9084V41.1475C65.5841 35.7573 61.1983 31.3715 55.8081 31.3715H40.1921Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 59.2167C41.8302 59.2167 36.8115 54.1972 36.8115 48.0283C36.8115 41.8594 41.8302 36.8398 48 36.8398C54.1697 36.8398 59.1884 41.8585 59.1884 48.0283C59.1884 54.1981 54.1697 59.2167 48 59.2167ZM48 39.6318C43.3706 39.6318 39.6044 43.3981 39.6044 48.0274C39.6044 52.6567 43.3706 56.423 48 56.423C52.6293 56.423 56.3955 52.6567 56.3955 48.0274C56.3955 43.3981 52.6293 39.6318 48 39.6318Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3387 37.1841C61.3387 38.4659 60.2996 39.505 59.0178 39.505C57.736 39.505 56.696 38.4659 56.696 37.1841C56.696 35.9023 57.736 34.8623 59.0178 34.8623C60.2996 34.8623 61.3387 35.9014 61.3387 37.1841Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.62e28c96d9b1c2cf659c57b8b5668035.svg";
export { ForwardRef as ReactComponent };